import { render, staticRenderFns } from "./Wishlist.vue?vue&type=template&id=3ffdb676&scoped=true&"
import script from "./Wishlist.vue?vue&type=script&lang=js&"
export * from "./Wishlist.vue?vue&type=script&lang=js&"
import style0 from "./Wishlist.vue?vue&type=style&index=0&id=3ffdb676&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffdb676",
  null
  
)

export default component.exports